if (typeof WDN === "undefined") {
  WDN = {};
}

if (typeof WDN.mobileGallery === "undefined") {
  WDN.mobileGallery = (function () {
    var _settings = {
      toShowPC: $(".SlickProductGallery").data("items-pc"),
      toShowMobile: 1,
      toScroll: 1,
      slideSpeed: 200,
    };

    var _selectors = {
      gallery: $(".SlickProductGallery"),
      slideToVideo: $(".MobileGoToVideo"),
    };

    var _nav = {
      prev: '<span class="slick-prev"></span>',
      next: '<span class="slick-next"></span>',
    };

    _selectors.gallery.slick({
      dots: false,
      infinite: true,
      speed: _settings.slideSpeed,
      prevArrow: _nav.prev,
      nextArrow: _nav.next,
      slidesToShow: _settings.toShowPC,
      slidesToScroll: _settings.toScroll,
      responsive: [
        {
          breakpoint: 1060,
          settings: {
            slidesToShow: 2,
            slidesToScroll: _settings.toScroll,
          },
        },
        {
          breakpoint: 625,
          settings: {
            infinite: true,
            centerMode: true,
            centerPadding: "30px",
            dots: true,
            slidesToShow: _settings.toShowMobile,
            slidesToScroll: _settings.toScroll,
          },
        },
      ],
    });

    function playVideo() {
      var pdp_gallery = document.querySelector(".SlickProductGallery");
      var firstVideoItem = pdp_gallery.querySelector(".slick-active");
      var videoSlide = firstVideoItem.querySelector("wdn-pdp-video video");
      var playPromise = videoSlide.play();
      playPromise
        .then(() => {
          videoSlide.classlist.add("activeVideo");
        })
        .catch((error) => {
          console.warn(error);
          if (error.name === "NotAllowedError") {
          }
        });
    }

    // Scroll to video slide on click on minicontrol element on mobile
    _selectors.slideToVideo.on("click", function (e) {
      var pdp_gallery = document.querySelector(".SlickProductGallery");
      var firstVideoItem = pdp_gallery.querySelector(
        '.item[data-media-type="video"]'
      );
      var videoIndex = parseInt(
        firstVideoItem.getAttribute("data-media-index0")
      );

      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, 300);

      _selectors.gallery.slick("slickGoTo", videoIndex);

      playVideo();
    });
  })();
}

if (typeof WDN.productDescription === "undefined") {
  WDN.productDescription = (function () {
    var _classes = {
      mobileToggle: ".toggleProductDescription",
      wrap: ".productDescriptionWrap",
      showMore: ".showMore",
      showFull: "showFull",
    };

    $(_classes.wrap + " " + _classes.showMore).on("click", function () {
      var $elem = $(this);
      $elem.remove();
      $(_classes.wrap).addClass(_classes.showFull);
    });

    $(_classes.mobileToggle).on("click", function (e) {
      e.preventDefault();
      $(_classes.wrap).slideToggle(300);
    });
  })();
}

if (typeof WDN.language === "undefined") {
  WDN.language = (function () {
    var _s = {
      trigger: $("._language_trigger"),
      main: $("._language_select"),
      option: $("._language_option"),
      footer_trigger: $("._language_dropdown--footer"),
    };

    var _class = {
      open: "_language_select--open",
    };

    var dropdown = {
      e: _s.main,
      _open: function () {
        dropdown.e.addClass(_class.open);
        $("body").addClass("language--open");
        mountClick();
      },
      _close: function () {
        dropdown.e.removeClass(_class.open);
        dismountClick();
        $("body").removeClass("language--open");
      },
      _isOpen: function () {
        return dropdown.e.hasClass(_class.open);
      },
      _toggle: function () {
        if (dropdown._isOpen()) {
          dropdown._close();
        } else {
          dropdown._open();
        }
      },
    };

    function outsideClickClose(e) {
      var container = _s.main;

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        dropdown._close();
      }
    }

    function mountClick() {
      $("body.language--open").on("mousedown", function (e) {
        outsideClickClose(e);
      });
    }

    function dismountClick() {
      $("body").off("mousedown", outsideClickClose);
    }

    var redirectTo = function (url, iso) {
      window.location.href = url;
    };

    // toggle dropdown
    _s.trigger.on("click", function (e) {
      dropdown._toggle();
    });

    _s.option.on("click", function () {
      if (dropdown._isOpen()) {
        var _url = $(this).attr("data-redirect-url");
        var _iso = $(this).attr("data-redirect-iso");

        redirectTo(_url, _iso);
      }
    });

    _s.footer_trigger.on("change", function () {
      var _url = $(this).val();
      var _iso = $(this).find("option:selected").attr("data-redirect-iso");

      redirectTo(_url, _iso);
    });

    return {
      redirect: redirectTo,
    };
  })();
}

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.Tabs === "undefined") {
  WDN.Tabs = (function () {
    var Classes = {
      open: "Tab__item--open",
    };

    var Tab;

    var Construct;

    Tab = function (parent) {
      var parent_item = parent;

      // If we got a string, its a selector, so lets reference it,
      // Otherwise we expect to get a object, which is a reference to an element
      if (typeof parent === "string") {
        parent_item = document.querySelector(parent);
      }

      this.tabs = parent_item.querySelectorAll(".Tab__item");
    };

    Tab.prototype.closeAll = function () {
      var self = this;
      this.tabs.forEach(function (elem) {
        self.close(elem);
      });
    };

    Tab.prototype.openAll = function () {
      var self = this;
      this.tabs.forEach(function (elem) {
        self.open(elem);
      });
    };

    Tab.prototype.close = function (elem) {
      elem.classList.remove(Classes.open);
    };

    Tab.prototype.open = function (elem) {
      elem.classList.add(Classes.open);
    };

    Tab.prototype.toggle = function (elem) {
      elem.classList.toggle(Classes.open);
    };

    Tab.prototype.BindEvents = function () {
      var self = this;
      this.tabs.forEach(function (elem) {
        elem.addEventListener("click", function () {
          self.toggle(elem);
        });
      });
    };

    Construct = function (parent) {
      var _Tab = new Tab(parent);
      _Tab.BindEvents();
      return _Tab;
    };

    // Automatically bind all found using data-tabs-id
    var TabsList = document.querySelectorAll(".Tabs[data-tabs-id]");

    TabsList.forEach(function (elem) {
      Construct(elem);
    });

    return {
      Build: Construct,
    };
  })();
}

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.RelatedColors === "undefined") {
  WDN.RelatedColors = (function () {
    // Private var
    var Config, Product, Selectors, Classes, Search;

    // Public functions
    var Find;

    // "Imported" and renamed for faster reference
    var _Translations = Translations.product_page.related_colors;

    Config = {
      image_size: "200x", // image size used for markup
      search_endpoint: "/search/suggest.json", // api endpoint to call
    };

    // General selectors used
    Selectors = {
      target: ".Related__colors-target", // target for where to place found related colors
    };

    // Classes used for markup
    // Placed here for smaller and more compact templating
    Classes = {
      wrap: "RelatedColor slick-slider",
      wrap_title: "RelatedColor__section-title Text Text--size-small",
      item: "RelatedColor__item Flex__item Flex__item--one-fifth",
      title: "RelatedColor__title Text Text--size-xsmall Text--center",
      image: "RelatedColor__image",
    };

    // Search
    Search = {};

    // Get the name of current product
    Search.product_name = GlobalLiquidReferences.product_page.title;
    // Split product name up, so that we only get model name, and leave behind color values
    // It's needed to get all the results, of that current product model we're viewing
    if (Search.product_name) {
      Search.query = Search.product_name.split(" - ")[0].toString();
    }

    Search.Config = {
      type: "product",
      limit: 10,
      options: {
        unavailable_products: "hide",
        fields: "title",
      },
    };

    Product = {};

    Find = function (query, callback) {
      if (query) {
        Search.product_name = query;
        Search.query = query.split(" - ")[0].toString();
      }

      $.ajax({
        url: Config.search_endpoint,
        data: {
          q: Search.query, // Use parameter, or "internal" search query, from liquid
          resources: Search.Config, // Config to only search by title, and other settings
        },
        success: function (res) {
          // If we have a callback, lets call it with the response
          if (typeof callback === "function") {
            callback(res);
          } else {
            // If we have a product response thats more than 1
            // +1 is needed, as we should always get at least 1 response
            // Since we're searching for a product by its name,
            // while we're on the productpage, meaning that we know it exists
            if (res.resources.results.products.length > 1) {
              // We found a product, let's render the contents to the markup
              Product.render(res.resources.results.products);
            } else {
              // Else hide container
              if (document.querySelector(".product-single__meta")) {
                document
                  .querySelector(".product-single__meta")
                  .classList.add("no-related-colors");
              }
            }
          }
        },
        error: function (res) {

        },
      });
    };


    Product._filter = function (Products) {
      // Turn res obj into array
      return Object.keys(Products)
        .map(function (item) {
          return Products[item];
        })
        .filter(function (Product) {
          if (
            Product.title != Search.product_name &&
            Product.title.indexOf(Search.query) > -1
          ) {
            return Product;
          }
        });
    };

    Product.buildSingleItem = function (product) {
      return `
<div class="${Classes.item}">
<a href="${product.url}">
${Product._buildImage(product.image, Config.image_size)}
</a>
</div>
`;
    };

    Product._buildTitle = function (title) {
      return `
			<p class="${Classes.title}">
			  ${title.replace("-", "").replace(Search.query, "")}
			</p>
	   `;
    };

    Product._buildImage = function (src, size) {
      var format = "." + src.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[1];
      var image = src.replace(format, "_" + size + format);
      // returns the image in the correct size, and as markup
      return `<img class="${Classes.image}" src="${image}"/ title="Related color image">`;
    };

    Product.buildAll = function (Products) {
      return Product._filter(Products).map(function (product) {
        return Product.buildSingleItem(product);
      });
    };

    Product.render = function (Products) {
      $(Selectors.target).html(
        // Setup title
        `<p class="${Classes.wrap_title}">
    	    ${_Translations.title}
        </p>
        <div class="${Classes.wrap}">
	        ${Product.buildAll(Products).join("")}
        </div>
	   `
      );

      $(".RelatedColor").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        margin: 10,
        prevArrow: '<button type="button" class="slick-prev"><</button>',
        nextArrow: '<button type="button" class="slick-next">></button>',
      });
    };

    if (Search.product_name) {
      if (Search.product_name.length > 1) {
        if (Selectors.target) {
          Find();
        }
      }
    }

    return {
      Find: Find,
    };
  })();
}

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.Loading === "undefined") {
  WDN.Loading = (function () {
    var names;
    var initConfig;

    var add, remove;
    var addSingle, removeSingle;

    var set, unset;

    var _remove;

    names = {
      wrapper: "Is-loading",
      loader: "Loader",
      loader_outer: "Loading__outer",
    };

    initConfig = {
      size: "normal",
      theme: "light",
    };

    var _create;

    _create = function (target, settings) {
      var parent = document.createElement("DIV");
      var elem = document.createElement("DIV");

      parent.classList.add(names.loader_outer);

      target.classList.add(
        `${names.wrapper}--style-${settings.theme}`,
        `${names.wrapper}--style-${settings.size}`
      );

      elem.classList.add(names.loader);
      parent.appendChild(elem);
      return parent;
    };

    unset = function (selector) {
      if (typeof selector === "object") {
        _remove(selector);
      } else {
        remove(selector);
      }
    };

    set = function (selector, config) {
      // use default config
      var settings = Object.apply({}, initConfig);

      // Use passed in config object if available
      if (config && typeof config === "object") {
        settings = Object.assign(settings, config);
      } else {
        settings = initConfig;
      }

      if (typeof selector === "object") {
        addSingle(selector, settings);
      } else {
        var target = document.querySelectorAll(selector);
        add(target, settings);
      }
    };

    _remove = function (target) {
      var loader = target.querySelector(`.${names.loader_outer}`);
      if (loader) {
        loader.remove();
        target.classList.remove(
          `${names.wrapper}`,
          `${names.wrapper}--style-light`,
          `${names.wrapper}--style-dark`,
          `${names.wrapper}--style-normal`,
          `${names.wrapper}--style-thick`
        );
      }
    };

    add = function (target, settings) {
      remove(target);

      target.forEach(function (item) {
        var loader = _create(item, settings);
        item.classList.add(names.wrapper);
        item.appendChild(loader);
      });
    };

    addSingle = function (target, settings) {
      _remove(target);
      var loader = _create(target, settings);
      target.classList.add(names.wrapper);
      target.appendChild(loader);
    };

    remove = function (target) {
      if (typeof target === "string") {
        target = document.querySelectorAll(target);
      }
      target.forEach(function (item) {
        _remove(item);
      });
    };

    return {
      add: set,
      remove: unset,
    };
  })();
}

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.Api === "undefined") {
  WDN.Api = (function () {
    var Product = {};
    var Cart = {};

    // Fetch a single product via AJAX api
    Product.load = function (handle, cb) {
      var params = {
        url: `/products/${handle}`,
        dataType: "JSON",
        method: "GET",
        success: function (res) {
          if (typeof cb === "function") {
            cb(res);
          }
        },
        error: function (res) {
          if (typeof cb === "function") {
            cb(res, handle);
          }
        },
      };
      $.ajax(params);
    };

    // Add single product to cart
    Product.addSingle = function (id, cb) {
      var params = {
        url: "/cart/add.js",
        method: "POST",
        dataType: "json",
        data: {
          id: id,
          quantity: 1,
        },
        success: function (res) {
          if (typeof cb === "function") {
            cb(res);
          }
        },
      };
      $.ajax(params);
    };

    // Load cart

    Cart.load = function (cb) {
      if (typeof cb === "function") {
        $.getJSON("/cart.js", function (res) {
          cb(res);
        });
      }
    };

    // Expose to global local scope
    return {
      Product: Product,
      Cart: Cart,
    };
  })();
}

if (typeof WDN.ProductGridItem === "undefined") {
  WDN.ProductGridItem = (function () {
    // For rendering products

    var Names = {
      image_wrapper:
        "grid-view-item__image-wrapper product-card__image-wrapper js",
      link: "grid-view-item__link grid-view-item__image-container full-width-link",
      title: "h4 grid-view-item__title product-card__title",
      grid_image: "grid-view-item__image lazyload",
      grid_image_second: "image-second--wrap",
      grid_item: "Flex__item Flex__item--one-quarter FlexItem-small--half",
      grid_item_wrap: "product-card-grid grid-view-item product-card",
      data_widths: "[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]",
    };

    var Template = {};

    // Helpers
    Template._price_varies = function (variants) {
      var firstPrice = variants[0].price;

      var variedPrices = variants
        .map(function (item) {
          return item.price;
        })
        .filter(function (price) {
          if (price !== firstPrice) {
            return true;
          }
        });

      return !!variedPrices.length;
    };

    Template._is_on_sale = function (price, compare_price) {
      var on_sale = parseInt(compare_price) > parseInt(price);

      return on_sale;
    };

    Template._priceHelper = function (price, compare_price) {
      return `${
        Template._is_on_sale(price, compare_price)
          ? Template._money(compare_price)
          : Template._money(price)
      }`;
    };

    Template._priceRegular = function (price, compare_price, label) {
      var _label = "";

      if (!compare_price && label) {
        _label = label;
      }

      return `${_label}
				<div class="price__regular">
                  <dd>
                    <span class="price-item price-item--regular medium" data-regular-price>
                      ${Template._priceHelper(price, compare_price)}
                    </span>
                  </dd>
                </div>`;
    };

    Template._priceSale = function (price, compare_price) {
      return `<div class="price__sale">
                  <dd>
                    <span class="price-item price-item--sale" data-sale-price>
                      ${Template._priceHelper(price, 0)}
                    </span>
                  </dd>
                </div>`;
    };

    Template._priceHeader = function (price, compare_price) {
      return `<dl class="price${
        Template._is_on_sale(price, compare_price) ? " price--on-sale" : ""
      }" data-price>`;
    };

    Template._price = function (price, compare_price, variants) {
      var priceVaries = Template._price_varies(variants);
      var label = false;

      if (priceVaries) {
        label =
          '<span data-from-label class="Label">' +
          Translations.prices.labels.from +
          "</span>";
      }

      return `
            ${Template._priceHeader(price, compare_price)}
              ${Template._priceSale(price, compare_price)}
              ${Template._priceRegular(price, compare_price, label)}
            </dl>
    `;
    };

    Template._money = function (value) {
      return theme.Currency.formatMoney(value, theme.moneyFormat);
    };

    Template._imageSingle = function (img, _class) {
      return `<img class="${_class}"
              src="${Template._imageResize(img.src, "400x")}"
              data-src="${Template._imageResize(img.src)}"
              data-widths="${Names.data_widths}"
              data-aspectratio="${Template._imageAspectRatio(img)}"
            data-sizes="auto">`;
    };

    Template._image = function (img, img2) {
      return `<div class="${Names.image_wrapper}">
          <div style="padding-top:${100 / Template._imageAspectRatio(img)}%;">
              ${Template._imageSingle(img, Names.grid_image)}
          </div>
            ${
              Template._imageSecondExists(img2)
                ? Template._imageSingle(img2, Names.grid_image_second)
                : ""
            }
        </div>`;
    };

    // Custom resize function that works with responsive images,
    // See default imageSize
    Template._imageResize = function (image, size) {
      var imageSize = size || "{width}x";
      var exstension = "." + image.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[1];
      return image.replace(exstension, "_" + imageSize + exstension);
    };

    Template._imageAspectRatio = function (image) {
      return image.width / image.height;
    };

    Template._imageSecondExists = function (images) {
      return !!images;
    };

    Template._link = function (link) {
      return `<a class="${Names.link}" href="/products/${link}"></a>`;
    };

    Template._title = function (title) {
      return `<div class="${Names.title}" aria-hidden="true">${title}</div>`;
    };

    Template._vendor = function (vendor) {
      return `<div class="price__vendor">
              <span>
                ${vendor}
              </span>
            </div>`;
    };

    Template.item = function (product) {
      return `<div class="${Names.grid_item}">
                  <div class="${Names.grid_item_wrap} imageSwitchOnHover">
                    ${Template._link(product.handle)}
                    ${Template._image(product.images[0], product.images[1])}
                    ${Template._title(product.title)}
                    ${Template._vendor(product.vendor)}
                    ${Template._price(
                      product.variants[0].price,
                      product.variants[0].compare_at_price,
                      product.variants
                    )}
                  </div>
                </div>`;
    };

    // Actual render function
    Template.render = function (product) {
      return Template.item(product);
    };

    return {
      render: Template.render,
    };
  })();
}

if (typeof WDN.ViewedProducts === "undefined") {
  WDN.ViewedProducts = (function () {
    var History = {};

    History.currentHandle = false;

    if (document.getElementById("ProductJson-product-template")) {
      if (document.getElementById("ProductJson-product-template").innerText) {
        if (
          JSON.parse(
            document.getElementById("ProductJson-product-template").innerText
          ).handle
        ) {
          History.currentHandle = JSON.parse(
            document.getElementById("ProductJson-product-template").innerText
          ).handle;
        }
      }
    }

    History.name = "viewedItems";

    History.set = function (handle) {
      if (typeof handle === "string") {
        // Read current storage
        var products = History.read();

        var foundIndex = products.indexOf(handle);
        // If found, update position in arr
        if (foundIndex !== -1) {
          // Remove from arr
          products.splice(foundIndex, 1);
        }
        // add new product to the list
        products.unshift(handle);

        // Set storage as JSON
        localStorage.setItem(History.name, JSON.stringify(products));
      }
    };

    History.read = function () {
      return JSON.parse(localStorage.getItem(History.name)) || [];
    };

    History.clear = function () {
      localStorage.removeItem(History.name);
    };

    History.removeSingle = function (handle) {
      var products = History.read();
      var foundIndex = products.indexOf(handle);
      products.splice(foundIndex, 1);
      localStorage.setItem(History.name, JSON.stringify(products));
    };

    return {
      History: History,
    };
  })();
}

if (typeof WDN.ViewedProductsProductPage === "undefined") {
  WDN.ViewedProductsProductPage = (function () {
    // Products
    var ProductElement = document.querySelector(".Product__single");
    var Products = {};

    // Storage for products
    Products.list = [];

    // Read handle of current product we're viewing
    Products.currentHandle = WDN.ViewedProducts.History.currentHandle;

    Products.productIgnore = false;

    if (ProductElement) {
      if (ProductElement.getAttribute("data-ignore-in-history") == "true") {
        Products.productIgnore = true;
      }
    }

    Products.handles = WDN.ViewedProducts.History.read();

    // Remove product from list, if we're on the page of it
    Products.handles = Products.handles.filter(function (item) {
      if (Products.currentHandle != item) {
        return true;
      }
    });

    // After cleaning up, lets make sure we only load 4 products
    Products.handles.splice(4);

    Products.load = function () {
      // Access current handle of product to load
      var handle = Products.handles[0];
      if (handle) {
        // Remove from product handles list
        Products.handles.shift();
        // Actual load of product, with Products.add as our callback function
        WDN.Api.Product.load(handle, Products.add);
      }
    };

    Products.render = function () {
      var RawHTML = "";

      // Only load products if more than 2 products found
      if (Products.list.length > 2) {
        Products.list.forEach(function (item) {
          RawHTML += WDN.ProductGridItem.render(item.product);
        });

        // RawHTML now holds the markup for the section
        var Target = document.querySelector(
          "[data-product-recommendations-section]"
        );
        // Lets append it
        if (Target) {
          Target.insertAdjacentHTML(
            "beforebegin",
            `<div class="shopify-section-recently-viewed"><div class="page-width"><p class="h2 title">${Translations.product_page.recently_viewed.title}</p><div class="Flex Flex--wrap Flex--gutters-small">${RawHTML}</div></div></div>`
          );
        }
      }
    };

    Products.add = function (res, handle) {
      // If we didnt get a product returned, lets remove from storage
      // Most likely isnt a product thats available anymore
      if (!res.product) {
        WDN.ViewedProducts.History.removeSingle(handle);
      }

      // We got a product, push to the list
      if (res.product) {
        Products.list.push(res);
      }
      // If we have more products in queue
      if (Products.handles.length > 0) {
        Products.load(Products.handles[0]);
      } else {
        // If we dont have to load more products, lets render them
        Products.render();
      }
    };

    // Start up function
    Products.init = function () {
      if (Products.currentHandle) {
        // Update history
        if (!Products.productIgnore) {
          WDN.ViewedProducts.History.set(Products.currentHandle);
        }

        Products.load();
      }
    };

    // Load viewed products on load
    Products.init();
  })();
}

$(document).ready(function () {
  $(".footer-trigger").on("click", function () {
    if ($(window).width() < 600) {
      $(this).next().slideToggle(250);
    }
  });
});

WDN.LoaderBarTop = (function () {
  var config = {
    active: true,
    autoEnd: false,
  };

  var body = document.querySelector("body");
  var loadParent = document.querySelector("[data-page-loadbar]");

  // Build the events
  var _eventStart = function () {
    return new CustomEvent("page:beginloading");
  };

  var _eventEnd = function () {
    return new CustomEvent("page:endloading");
  };

  // Emit the event
  var _emitStartLoad = function () {
    var e = _eventStart();
    body.dispatchEvent(e);
  };

  var _emitEndLoad = function () {
    var e = _eventEnd();
    body.dispatchEvent(e);
  };

  // Auto end load event
  var _endLoadStateLater = function () {
    if (config.autoEnd) {
      setTimeout(function () {
        _handleLoadEnd();
      }, config.autoEnd);
    }
  };

  // Actual controllers
  var _handleLoadBegin = function () {
    loadParent.setAttribute("data-active", "");

    _endLoadStateLater();
  };

  var _handleLoadEnd = function () {
    loadParent.removeAttribute("data-active");
    loadParent.setAttribute("data-end", "");

    setTimeout(function () {
      loadParent.removeAttribute("data-end");
    }, 275);
  };

  // Add emitters on body
  var _listenForLoad = function () {
    body.addEventListener("page:beginloading", _handleLoadBegin);
    body.addEventListener("page:endloading", _handleLoadEnd);
  };

  var init = function () {
    if (body && loadParent) {
      _listenForLoad();
    }
  };

  // Only run module if active
  if (config.active) {
    init();
  }

  return {
    start: _emitStartLoad,
    end: _emitEndLoad,
  };
})();

class CartFreegift extends HTMLElement {
  constructor() {
    super();
  }

  readConfig() {
    this.config = {};
    this.config.action = this.dataset.action;
    this.config.custom_prop_name = this.dataset.customPropName;
    this.config.variant_id = this.dataset.variantId;

    if (this.config.action == "idle") {
      return;
    }

    this.updateCartItem();
  }

  updateCartItem() {
    this.freeGiftItem = {};
    this.freeGiftItem.id = this.config.variant_id;
    this.freeGiftItem.quantity = 0;
    this.freeGiftItem.properties = {};
    this.freeGiftItem.properties[this.config.custom_prop_name] = "yes";

    if (this.config.action == 'add') {
      this.freeGiftItem.quantity = 1;
      this.formData = {items: [this.freeGiftItem]};
      this.addGiftToCart();
      return;
    }

    this.formData = this.freeGiftItem;
    this.removeGiftFromCart();
  }

  removeGiftFromCart() {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.formData),
    })
      .then((response) => {
        WDN.CartDrawer.reload();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
    });
  }

  addGiftToCart() {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.formData),
    })
      .then((response) => {
        WDN.CartDrawer.reload();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
    });
  }

  connectedCallback() {
    this.readConfig();
  }
}

customElements.define("cart-freegift", CartFreegift);

class WDNVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(this);

      if (!this.querySelector('video').hasAttribute('autoplay')) {
        this.querySelector('video').play();
      }
    };
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  
    observer.observe(this);
  }
}

customElements.define("wdn-video", WDNVideo);